import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';

const tabItems = [
    {
        label: "Locker",
        path: "locker",
        index: 1
    },
    {
        label: "CBT",
        path: "cbt",
        index: 2
    },
    {
        label: "Chatroom",
        path: "chatroom",
        index: 3
    }
];

const FooterNav = () => {
  const location = useLocation();

  return(
    <div className='sm:hidden h-16 flex w-full px-4 bg-white'>
      <div className='w-full'>
        <div className='flex justify-center w-full'>
          { tabItems.map((item) => {
              const isCurrentRoute = location.pathname === `/${item.path}`;
              const showBar = classNames({
                'bg-white rounded-b h-1 block w-full mb-5' : true,
                'bg-blue-100': isCurrentRoute
              });
              
            return(
            <div key={item.index} className='block w-full'>
              <span className={showBar} />
              <Link to={item.path}>
                <div className='w-20 mt-4 text-gray-100 text-sm mx-auto text-center'>
                    {item.label}
                </div>
              </Link>
            </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default FooterNav;
